import { render } from "./SignupBox.vue?vue&type=template&id=7436cde8&scoped=true"
import script from "./SignupBox.vue?vue&type=script&lang=js"
export * from "./SignupBox.vue?vue&type=script&lang=js"

import "./SignupBox.vue?vue&type=style&index=0&id=7436cde8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7436cde8"]])

export default __exports__